export class OrderConstants {
  static readonly Messages = {
    NoTrackingInfoFoundMessage: 'No package information available.',
    NoOrderDetailFoundMessage: 'No order details available.',
    DiscontinuedProductMessage:
      '*** Information currently unavailable. To view missing details, please reference your invoice.',
    NoOrderFoundMessage:
      'We do not show any orders on file for this account. Please contact your Sales Representative ' +
      'or our Customer Service department at',
    NoCsosOrderFoundMessage:
      'We currently don’t have any submitted CSOS orders for this account.',
    CsosOrderDetailMissingDataTitle: 'Complete',
    CsosOrderDetailMissingDataMessage:
      'Please enter the date and quantity for the record before proceeding.',
    ConfirmOrderSubmitDialogTitle: 'Confirm Order Submission',
    ConfirmOrderSubmitDialogMsg:
      'You will not be able to edit this order after submitting it. Do you wish to continue?',
    ConfirmOrderSubmitDialogYesText: ' Yes, submit my order',
    ConfirmOrderSubmitDialogNoText: 'No, I need to make changes',
    CreditCardPaymentFailedMessage:
      'There was an error processing your credit card payment. Do not attempt another payment. ' +
      'Please contact our credit department at 800-955-0738 for further assistance with your payment.',
    CreditCardCVVRequired: 'Please enter the credit card verification code.',
    CreditCardCVVValidate: 'Please verify the credit card verification code.',
    CSOSRequiredMessage: 'CSOS order number is required.',
    CSOSInvalidMessage: 'Please enter a valid CSOS order number.',
    CSOSLengthMessage:
      'Your CSOS order number must be 6 characters in length. Please enter a new CSOS order number and select Submit Order to proceed.',
    CSOSSigningGenericError: `Oops! Something went wrong on our end.<br><br>
    Please re-enter your password and click Sign Order to continue.
    If the problem persists, contact our Customer Service department at 800.727.6331.<br><br>
    Thank you!`,
    CSOSSigningIncorrectCertPasswordError:
      'The password you entered is not valid.  Please re-enter your password and try again.',
    CSOSSigningCertExpiredError:
      'Your CSOS signing certificate is expired or no longer valid, please contact your DEA office.',
    CSOSSigningUsernotAuthorized:
      'In order to complete signing your order, you must register your certificate first.' +
      '<br /><br />To register your certificate, please click Cancel below and then click the Register Certificate button ' +
      'near the top of the Order Review page.',
    NoOrderHistoryFoundMobileMessage:
    'No recent orders are on file for this account. ' +
    'Please contact your sales representative or our Customer Service department at ',
    ProductDiscontinuedMobileMessage:
    'This product has been discontinued. To view additional details, please reference your invoice.',
    NoInvoiceFoundMessage:
    'No past invoices found.',
    NoInvoiceDocument:
    'Some documents may not be viewable, please contact your credit representative for details.',
    PaymentFailed:
    'Unable to process the payment, please call 734-743-6050 for assistance.',
    NoDSCSADocument:
    'No DSCSA document found.',
  };

  static readonly Status = {
    InProcess: 'In Process',
    Submitted: 'Submitted',
    Completed: 'Completed',
    Rejected: 'Rejected'
  };

  static readonly SupplierDefaultData = {
    OrderDate: '02/04/2017',
    Name: 'PARMED PHARMACEUTICALS',
    RegistrationNumber: 'RC0501014',
    Address:
      'PARMED PHARMACEUTICALS<br>5960 E. SHELBY DRIVE<br>STE 100<br>MEMPHIS, TN &nbsp; &nbsp; 38141'
  };

  static readonly ErrorCodes = {
    DuplicateUTN: 'ORD012'
  };
}

export enum OrderAccount {
  Hawaii = 'HI',
  Alaska = 'AK'
}

export enum OrderMethod {
  None = 'none',
  Paper = 'Paper',
  Electronic = 'Electronic'
}

export enum PaymentTypes {
  PayOnTerms = 'Pay On Terms',
  CreditCard = 'Manage Credit Cards'
}

export enum PaymentOptions {
  None = 'none',
  PayOnTerms = 'PAYONTERMS',
  CreditCard = 'CREDITCARD'
}
